import * as moment from 'moment';

import {
  APP_LOCAL_DATETIME_FORMAT,
  APP_LOCAL_TIME_FORMAT_WITH_MIN,
  APP_TIMESTAMP_FORMAT,
  APP_LOCAL_DATE_FORMAT,
  APP_LOCAL_TIME_FORMAT,
  APP_LOCAL_TIME_FORMAT_ALL,
  APP_LOCAL_DATE_ONLY_FORMAT
} from 'app/config/constants';

export const convertDateTimeFromServer = date => (date ? moment(date).format(APP_LOCAL_DATETIME_FORMAT) : null);

// moment.locale('zh-HK');
export const convertToDisplay = dateInMoment => moment(dateInMoment).format(APP_LOCAL_DATE_FORMAT);

export const convertToDisplayWithTime = dateInMoment => {
  let result = moment(dateInMoment).format(APP_LOCAL_DATE_ONLY_FORMAT);
  if (moment(dateInMoment).minutes() > 0) result += ' ' + moment(dateInMoment).format(APP_LOCAL_TIME_FORMAT_WITH_MIN);
  else result += ' ' + moment(dateInMoment).format(APP_LOCAL_TIME_FORMAT);
  return result;
};

export const convertToWeekday = dateInMoment => moment(dateInMoment).format('dddd');

export const convertToTime = dateInMoment => {
  const m = moment(dateInMoment);
  if (m.minute() === 0) return m.format(APP_LOCAL_TIME_FORMAT);
  else return m.format(APP_LOCAL_TIME_FORMAT_WITH_MIN);
};

export const jetcoTimestampToDateTime = timestamp =>
  moment
    .utc(timestamp, 'YYYYMMDDHHmmss')
    .local()
    .format(APP_TIMESTAMP_FORMAT);

export const nowDateTime = () => moment().format(APP_LOCAL_TIME_FORMAT_ALL);
